import React from "react";
import { FormattedMessage as FM } from "react-intl";

function EmptyZone({ model }) {
  return (
    <div className="flex col-span-2 rounded-lg bg-neutral-200 w-full min-h-40">
      <span className="m-auto text-neutral-300 font-bold text-4xl">
        <FM id={model} key={model} />
      </span>
    </div>
  );
}

export default EmptyZone;
